import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M25.88 9a16.085 16.085 0 00-11.963 5.352 1.516 1.516 0 002.26 2.016 13.023 13.023 0 11-2.487 13.236h1.516a1.516 1.516 0 001.496-1.694 1.517 1.517 0 00-.314-.762l-3.805-4.549a1.516 1.516 0 00-1.243-.576 1.516 1.516 0 00-1.168.561l-3.82 4.549a1.516 1.516 0 001.167 2.486h3.033A16.056 16.056 0 1025.879 9z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M25.883 15.58a1.516 1.516 0 00-1.516 1.516v9.476a1.516 1.516 0 001.516 1.516h5.67a1.516 1.516 0 000-3.032H27.4v-7.96a1.516 1.516 0 00-1.516-1.516z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
